import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
var BackpanelMaterialView = /** @class */ (function (_super) {
    tslib_1.__extends(BackpanelMaterialView, _super);
    function BackpanelMaterialView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.moveNextPrevented = false;
        _this.moveNextTimer = null;
        return _this;
    }
    BackpanelMaterialView.prototype.moveNext = function () {
        this.moveNextPrevented = true;
        var self = this;
        this.moveNextTimer = setTimeout(function () { return self.moveNextPrevented = false; }, 3000);
    };
    Object.defineProperty(BackpanelMaterialView.prototype, "materialCode", {
        get: function () {
            if (!this.$state.material && !this.$state.graphics)
                return null;
            if (this.$state.graphics == "00" && this.$state.material == "S")
                return "S";
            return this.$state.material == "K" ? "K" : this.$state.graphics || "S";
        },
        set: function (value) {
            //Material is S, if anything else but deko is selected
            this.$state.material = value == "K" ? "K" : "S";
            //Set graphics if material is anything but deko
            this.$state.graphics = value != "K" && value != "S" ? value : null;
        },
        enumerable: true,
        configurable: true
    });
    BackpanelMaterialView = tslib_1.__decorate([
        Component
    ], BackpanelMaterialView);
    return BackpanelMaterialView;
}(Vue));
export default BackpanelMaterialView;
